;(function () {
  "use strict"

  window.normalizeUrl = function (url) {
    const urlPattern = /^((\w)*[:/]+)?(.+)?$/i

    // Remove all spaces and match the pattern
    const cleanUrl = url.replace(/ /g, "")
    const match = cleanUrl.match(urlPattern)

    if (!match) return ""

    const [, , ssl, domain] = match

    if (!domain) return ""

    // Check if SSL should be used (only if exactly 's' - case insensitive)
    const sslProtocol = ssl && ssl.toLowerCase() === "s" ? "s" : ""

    // Normalize slashes in path like some//slashed///path/ => some/slashed/path
    const normalizedDomain = `/${domain}/`.split(/\/+/).slice(1, -1).join("/")

    // Compound url with correct protocol identifier
    return `http${sslProtocol}://${normalizedDomain}`
  }
})()
